import { Component, Inject } from '@angular/core';
import { EnvironmentServiceBase } from '@sg/common';
import { SgAppBranding } from '@sg/pre-app-init/src';

@Component({
  selector: 'sg-cookie-policy',
  templateUrl: './cookie-policy.component.html',
  styleUrls: ['./cookie-policy.component.scss'],
  standalone: false,
})
export class CookiePolicyComponent<T extends string = string> {
  readonly logoSrc: string;

  constructor(@Inject(EnvironmentServiceBase) env: { branding: SgAppBranding<T> }) {
    this.logoSrc = env.branding.logo;
  }
}
